namespace JupitersChoice {
    export class ShowSpinnerCmd {
        @inject('OrientationModel') _orientationModel: Sapphire.OrientationModel;
        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;

        execute(): void {
            const response: any = this._gameServer.logicResponse;
            const spinner = this._componentManager.get('Spinner');
            const dustAnimation = this._componentManager.get('SpinnerDust');
            const orientation: string = this._orientationModel.getCurrentOrientation();
            var firstLockedReel: number;

            for (let i = 0; i < response.lockedWithPreviousReel.length; i++) {
                if (response.lockedWithPreviousReel[i]) {
                    firstLockedReel = i - 1;
                    break;
                }
            }

            const landscapeReelSpacing = 236;
            const portraitReelSpacing = 160;
            this.resetSpinner(spinner);

            // Set end position of spinner in case device is rotation during animation
            spinner.data.position.landscape = {
                x: landscapeReelSpacing * firstLockedReel, 
                y: 100
            };
            spinner.data.position.portrait = {
                x: portraitReelSpacing * firstLockedReel, 
                y: 100
            };
            spinner.setPosition(spinner.data.position[orientation].x);

            // Set position of dust animation
            dustAnimation.data.position.landscape = {
                x: -55 + 60 * firstLockedReel,
                y: 100 
            };
            dustAnimation.data.position.portrait = {
                x: -130 + 55 * firstLockedReel,
                y: 200 
            };
            dustAnimation.setPosition(
                dustAnimation.data.position[orientation].x, 
                dustAnimation.data.position[orientation].y
            );

            // reset arrow positions
            this._componentManager.get('SpinnerOuterHighlight').rotation = 0;
            this._componentManager.get('OuterArrow').reset();
            this._componentManager.get('InnerArrow').reset();

            //var lightningHighlightAnimation = this._componentManager.get('Lightning');
            //spinner.setPosition(204 + (266 * logicResponse.syncReels[0]));

            this._componentManager.get('LightningSeparator').play();

            TweenMax.delayedCall(.6, () => {
                // Set mask for the reels that should hide when showing the spinner
                const reelMask = this._componentManager.get('SpinnerReelMask');
                for (let i = firstLockedReel; i < firstLockedReel + 3; i++) {
                    this._componentManager.get('Reels').reels[i].mask = reelMask;
                }
                this._layerManager.setVisibility('Spinner', true);

                spinner['drop']();
                TweenMax.delayedCall(1.2, () => {
                    dustAnimation.play(() => {
                        dustAnimation.hide();
                        dustAnimation.reset();
                    });
                });
                //lightningHighlightAnimation.setPosition(-670 + (266 * firstLockedReel), -140)
                //lightningHighlightAnimation.play();
            });

            TweenMax.delayedCall(4, () => {
                this._eventManager.publish('onStartSpinners');
            });
        }

        resetSpinner(spinnerObject: any): void {
            spinnerObject.y = -550;
            spinnerObject.show();
        }
    }
}